<template>
  <form>
    <v-row>
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit :form="journal" :accounts="accounts" ref="formEdit" v-if="!edit"></form-edit>
        <detail :id="id" :form="journal" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('in-transit.update')"
                  color="success"
                  v-on="on"
                  @click="updateItem"
                >
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="viewProduct">
                  <v-icon>
                    mdi-eye
                  </v-icon>
                </v-btn>
              </template>
              <span>Detail</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('in-transit.update')"
                  color="success"
                  v-on="on"
                  @click="editItem"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('in-transit.delete')"
                  color="error"
                  v-on="on"
                  @click.stop="deleteDialog"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="`${journal.id}`"
      title="Journal Product In Transit"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <product-dn :dialog="dialogDn" :items="items" @close="close"></product-dn>
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="JournalProductInTransit"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "../DetailJournal.vue";
import FormEdit from "../FormJournal.vue";
import DialogDelete from "@/components/DialogDelete";
import ProductDn from "./ProductDn.vue";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "journal-product-in-transit-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    ProductDn,
    DialogAuditHistory,
  },
  props: {
    id: Number,
    type: String,
    relationId: Number,
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogDn: false,
    dialogAuditHistory: false,
    accounts: [],
    journal: {},
    items: [],
  }),
  methods: {
    async getJournal() {
      await this.$store
        .dispatch("inventory/getJournal", { id: this.id, type: this.type })
        .then(response => (this.journal = response.data));
    },
    async getAcocunts() {
      await this.$store
        .dispatch("chartOfAccount/getAccounts")
        .then(response => (this.accounts = response.data));
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    async deleteItem() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("inventory/deleteJournal", { id: this.id, type: this.type })
        .then(() => {
          this.dialog = false;
          this.$store.commit("SET_LOADER", false);
          this.$router.push({ name: "Journal Product In Transit" });
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = this.dialogDn = false;
    },
    cancel() {
      this.getJournal();
      this.edit = true;
    },
    async viewProduct() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("inventory/getDnDetail", this.relationId)
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
          this.dialogDn = true;
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    getInnitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([this.getAcocunts(), this.getJournal()])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInnitialData();
  },
};
</script>

<style></style>
